// ─── Canonical Element List ────────────────────────────
// Single source of truth for all element identifiers.
// Adding a new element: add to ELEMENTS → compiler forces ELEMENT_REGISTRY entry.

export const ELEMENTS = [
  "fire",
  "water",
  "lightning",
  "signal",
  "kinetic",
  "virus",
] as const;
export type Element = (typeof ELEMENTS)[number];
